/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiflowstyleretro3Inputs */

const en_aiflowstyleretro3 = /** @type {(inputs: Aiflowstyleretro3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retro`)
};

const de_aiflowstyleretro3 = /** @type {(inputs: Aiflowstyleretro3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retro`)
};

/**
* | output |
* | --- |
* | "Retro" |
*
* @param {Aiflowstyleretro3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowstyleretro3 = /** @type {((inputs?: Aiflowstyleretro3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowstyleretro3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowstyleretro3(inputs)
	return de_aiflowstyleretro3(inputs)
});
export { aiflowstyleretro3 as "aiFlowStyleRetro" }